export const contracts = {
  multicall: {
    address: "0x3CD8AD561cc3C40aF80A6c6d10e13482063aC0b9",
  },
  escrowedRewards: [
    {
      tokenName: "XY",
      tokenAddress: "0x55555555A687343C6Ce28C8E1F6641dc71659fAd",
      escrowPool: "0xDeD4042838a72C7A86bc76A6De6404950D430566",
      liquidityMiningManager: "0xb782148F1cbDa7036dE00dBEe1421EfaA21DdBA9",
      view: "0x326F3e076b08b3d9f5f058e5469f1d600a3F26e3"
    },
    {
      tokenName: "RBW",
      tokenAddress: "0x431cd3c9ac9fc73644bf68bf5691f4b83f9e104f",
      escrowPool: "0x76ccE1c2681CE4Af8E600341ad5060BEbd50ca39",
      liquidityMiningManager: "0xf50e4942820A338435D7a182B5e8996F6bdF0299",
      view: "0x49dAf466456329DD3772a06e3349DA486115275D"
    }
  ],
  singleTokenPool: {
    address: "0xDc81b9DAfeefdADEE29e36E289968a37De56C510",
  },
  lpPool: {
    address: "0x4F51687D1C465eb65167B2A9fC6bc28c2b39325c",
  },
  uniswapLpPairAddress : {
    address: "0xa97cc9ffaa625e18d12e2f739378e94120e73782"
  }
};
